export const homeAbout = [
	{
		id: 1,
		cover: "./images/Mission.png",
		title: "Mission",
		desc: "To provide precision-engineered solutions and superior job work services for aluminum parts, leveraging innovative fixtures ,relation gauges and cutting-edge technology to exceed customer expectations.",
	},
	{
		id: 1,
		cover: "./images/Vission.png",
		title: "Vision",
		desc: "To be the preferred partner for precision machining, fixture & relation gauges implementation, renowned for our commitment to quality, efficiency, and continuous innovation in the automotive industry.",
	},
	{
		id: 1,
		cover: "./images/Values.png",
		title: "Values",
		desc: "Our core values are precision, innnovation, customer focus, integrity, teamwork, continuous improvement and sustainability.We embed these values in our processes to drive efficient solutions and deliver impactful results.",
	},
];
export const homeAbout1 = [
	{
		id: 2,
		cover: "./images/Design.png",
		title: "Design",
		desc: "We specialize in designing precise jigs, fixtures, and gauges for aluminum die casting using advanced CAD and CREO skills. Our expertise ensures optimal solutions tailored to die casting processes."
	},
	{
		id: 2,
		cover: "./images/Manufacturing.png",
		title: "Manufacture",
		desc: "Our state-of-the-art manufacturing facilities, including VMC, CNC, Lathe, M1TR, and Tapping machines, ensure high-quality production with close tolerances. We utilize advanced technologies for precision manufacturing",
	},
	{
		id: 3,
		cover: "./images/quality.png",
		title: "Quality",
		desc: "Quality is paramount in the manufacturing industry. We always implementing stringent quality control measures throughout the design and manufacturing process &amp; ensures that our products meet industry standards and customer requirements.",
	},
];
export const awrapper = [
	{
		cover:
			"https://img.icons8.com/external-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto/80/ffffff/external-graduation-education-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto.png",
		data: "60 Lakhs +",
		title: "Tools Designed",
	},

	{
		cover: "https://img.icons8.com/ios/80/ffffff/athlete.png",
		data: "500+",
		title: "Fixtures Designed",
	},
	{
		cover:
			"https://img.icons8.com/external-outline-icons-maxicons/80/ffffff/external-calender-insurance-outline-outline-icons-maxicons.png",
		data: "4",
		title: "Clients",
	},
];

export const team = [
	{
		cover: "/images/t.webp",
		name: "Niranjan Langade",
		work: "CHIEF TECHNICAL OFFICER",
	},
	{
		cover: "/images/t.webp",
		name: "Niranjan Langade",
		work: "CHIEF TECHNICAL OFFICER",
	},
	{
		cover: "/images/t.webp",
		name: "Niranjan Langade",
		work: "CHIEF TECHNICAL OFFICER",
	},
	{
		cover: "/images/t.webp",
		name: "Niranjan Langade",
		work: "CHIEF TECHNICAL OFFICER",
	},
	{
		cover: "/images/t.webp",
		name: "Niranjan Langade",
		work: "CHIEF TECHNICAL OFFICER",
	},
	{
		cover: "/images/t.webp",
		name: "Niranjan Langade",
		work: "CHIEF TECHNICAL OFFICER",
	},
	{
		cover: "/images/t.webp",
		name: "Niranjan Langade",
		work: "CHIEF TECHNICAL OFFICER",
	},
	{
		cover: "/images/t.webp",
		name: "Niranjan Langade",
		work: "CHIEF TECHNICAL OFFICER",
	},
];
export const certificate = [
	{
		cover: "/images/ISO.png",
		name: "ISO 9001:2015",
	},
	// {
	// 	cover: "/images/c.png",
	// 	name: "ISO 9001:2015",
	// },
	// {
	// 	cover: "/images/c.png",
	// 	name: "ISO 9001:2015",
	// },
];
export const software = [
	{
		cover: "/images/creo.png",
		name: "CREO",
		work: " CREO is a CAD software developed by PTC, used for product design and development, particularly for creating 3D models and simulations.",
	},
];

export const instru = [
	{
		cover: "/images/i1.png",
		name: "Relation Gauge",
	},
	{
		cover: "/images/i2.png",
		name: "Thread Plug Gauge",
	},
	{
		cover: "/images/i3.jpg",
		name: "Paralisum Dial Gauge",
	},
	{
		cover: "/images/i4.jpg",
		name: "Depth Vernier Caliper",
	},
	{
		cover: "/images/i5.jpg",
		name: "Filler Gauge",
	},
	{
		cover: "/images/i6.webp",
		name: "Snap Gauge",
	},
];

export const design = [
	{
		cover: "/images/d1.png",
		name: "Assembly Fextures",
	},
	{
		cover: "/images/d2.png",
		name: "Break Load Fextures",
	},
	{
		cover: "/images/d3.png",
		name: "4-Axis Cradle",
	},
	{
		cover: "/images/d4.png",
		name: "Hydraulic Fixture",
	},
	{
		cover: "/images/d5.png",
		name: "HMH Fixture",
	},
	{
		cover: "/images/d6.png",
		name: "CNC Jaws",
	},
    {
		cover: "/images/d7.png",
		name: "LT Fixture",
	},
    {
		cover: "/images/d8.png",
		name: "Powder Coating Fixture",
	},
    {
		cover: "/images/d9.png",
		name: "Relation Gauge",
	},
];

export const faq = [
	{
		title: "How to Enroll This Online Courses?",
		desc: "This is the first item's accordion body. It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
	},
	{
		title: "Where It is hidden by default, until the collapse?",
		desc: "It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
	},
	{
		title: "How It is hidden by default, until the collapse?",
		desc: "It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
	},
	{
		title: "How to Enroll This Online Courses?",
		desc: "This is the first item's accordion body. It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
	},
	{
		title: "Where It is hidden by default, until the collapse?",
		desc: "It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
	},
	{
		title: "How It is hidden by default, until the collapse?",
		desc: "It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. It's also worth noting that just about any HTML can go within the .accordion-body, though the transition does limit overflow.",
	},
];
export const blog = [
	{
		id: 1,
		type: "admin",
		date: "MAR. 06, 2024",
		com: "3 COMMENTS ",
		title: "Build your Dream Career with JKPAT",
		desc: "Lorem dne iwufn nvia wueo iusa cone hfoi cisnabo efcnhd snicgy uasfu nacsy igdfn.",
		cover: "./images/b.jpg",
	},
	{
		id: 2,
		type: "admin",
		date: "MAR. 06, 2024",
		com: "5 COMMENTS ",
		title: "Build your Dream Career with JKPAT",
		desc: "Lorem dne iwufn nvia wueo iusa cone hfoi cisnabo efcnhd snicgy uasfu nacsy igdfn.",
		cover: "./images/b.jpg",
	},
	{
		id: 3,
		type: "user",
		date: "MAR. 06, 2024",
		com: "10 COMMENTS ",
		title: "Build your Dream Career with JKPAT",
		desc: "Lorem dne iwufn nvia wueo iusa cone hfoi cisnabo efcnhd snicgy uasfu nacsy igdfn.",
		cover: "./images/b.jpg",
	},
	{
		id: 4,
		type: "admin",
		date: "MAR. 06, 2024",
		com: "3 COMMENTS ",
		title: "Build your Dream Career with JKPAT",
		desc: "Lorem dne iwufn nvia wueo iusa cone hfoi cisnabo efcnhd snicgy uasfu nacsy igdfn.",
		cover: "./images/b.jpg",
	},
	{
		id: 5,
		type: "admin",
		date: "DMAR. 06, 2024",
		com: "3 COMMENTS ",
		title: "Build your Dream Career with JKPAT",
		desc: "Lorem dne iwufn nvia wueo iusa cone hfoi cisnabo efcnhd snicgy uasfu nacsy igdfn.",
		cover: "./images/b.jpg",
	},
	{
		id: 6,
		type: "user",
		date: "MAR. 06, 2024",
		com: "12 COMMENTS ",
		title: "Build your Dream Career with JKPAT",
		desc: "Lorem dne iwufn nvia wueo iusa cone hfoi cisnabo efcnhd snicgy uasfu nacsy igdfn",
		cover: "./images/b.jpg",
	},
];
export const testimonal = [
	{
		id: 1,
		name: "Customization",
		desc: "Tailored solution to fit specific client requirements",
		cover: "./images/t1.png",
	},
	{
		id: 2,
		name: "Experienced Team",
		desc: "Skilled professionals with extensive industry expertise",
		cover: "./images/t2.png",
	},
	{
		id: 3,
		name: "Solution Driven Approach",
		desc: "Innovative problem-solving to meet unique challenges.",
		cover: "./images/t3.png",
	},
];
